export default function Privacy() {
  const sections = [
    {
      h: "Overview",
      p: "Babu Baazar Retail Pvt Ltd (\"Babu Baazar\", \"we\", \"us\") operates babubaazar.in and the Babu Baazar mobile experience. This policy explains what data we collect from customers of Babu Baazar and how we use it. By using our services, you agree to the practices described below.",
    },
    {
      h: "Information we collect",
      p: "Account details (name, email, phone), delivery addresses, order history, device metadata (browser, IP, coarse location), and payment metadata (never full card numbers). If you contact support, we retain the correspondence to resolve your case.",
    },
    {
      h: "How we use it",
      p: "To process and deliver orders, generate GST-compliant invoices, send transactional updates (order confirmed, out for delivery, delivered), personalise product recommendations, prevent fraud, and comply with legal obligations under Indian law.",
    },
    {
      h: "Sharing",
      p: "We share the minimum necessary data with (a) Babu Store staff fulfilling your order, (b) delivery partners for last-mile drop, (c) payment processors, (d) SMS / email vendors for transactional messages, and (e) authorities if required by law. We do not sell your personal data.",
    },
    {
      h: "Your rights",
      p: "You can access, correct, or delete your data by writing to privacy@babubaazar.in. On deletion, we anonymise records that are required by law (e.g. tax invoices retained for 8 years per GST Act).",
    },
    {
      h: "Cookies",
      p: "We use essential cookies to keep you signed in and remember your cart. We use lightweight analytics cookies to understand usage — you can disable these in your browser without breaking checkout.",
    },
    {
      h: "Refunds & cancellations",
      p: "Orders can be cancelled while in \"Pending\" or \"Confirmed\" status. Once packed, cancellations may not be possible. Refunds for online payments are initiated within 24 hours and reach your account in 3–7 business days depending on your bank.",
    },
    {
      h: "Contact",
      p: "For any privacy question, write to privacy@babubaazar.in. For general support, write to hello@babubaazar.in.",
    },
  ];
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-12" data-testid="privacy-page">
      <div className="text-xs uppercase tracking-wider text-muted-foreground">Legal</div>
      <h1 className="text-4xl md:text-5xl font-display font-semibold mt-1">Privacy & Terms</h1>
      <p className="text-sm text-muted-foreground mt-2">Last updated: February 2026</p>

      <div className="prose prose-sm max-w-none mt-8 space-y-8">
        {sections.map((s, i) => (
          <section key={i}>
            <h2 className="text-2xl font-display font-semibold text-foreground">{s.h}</h2>
            <p className="text-muted-foreground leading-relaxed mt-2">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
